<!--Main Container-->
<div class="MainMenu">
	<!--Header-->
	<div class="HeaderCenter">
		<h4>Select a Section:</h4>
	</div>

	<!--Top, Selector-->
	<div class="SemesterSelect">
		<label style="margin: 0">School:</label>
		<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="SchoolID">
            <option value="" style="display:none;"></option>
            <option *ngFor="let o of lstSchool" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
        </select> -->

		<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>

		<label style="margin: 0">Date:</label>
		<p-calendar
			[disabled]="loading"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="SelectDate"
			(ngModelChange)="onDateChange($event)"
			name="SelectDate"
		></p-calendar>

		<label style="margin: 0">Jump To Semester:</label>
		<p-dropdown
			[disabled]="loading"
			[options]="SemesterList"
			(ngModelChange)="onSemesterChange($event)"
			[(ngModel)]="SemesterSelect"
			[showClear]="true"
			optionLabel="FullDesc"
			(onHide)="onDeselectSemester($event)"
			placeholder="Select a Semester"
		>
			<ng-template let-o pTemplate="item">
				<div>
					<div>
						<label>{{ o.Semester }}:</label>{{ o.Desc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstSection"
			[loading]="loading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedSection"
			dataKey="SectionScheduleDetailID"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--CourseDesc-->
					<th>
						<p-columnFilter field="CourseDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterCourseDesc
									[ngModel]="value"
									[options]="lstCourseDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SectionNo-->
					<th>
						<p-columnFilter type="text" field="SectionNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--Semester-->
					<th>
						<p-columnFilter field="Semester" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSemester
									[ngModel]="value"
									[options]="lstSemester"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--PeriodNo-->
					<th>
						<p-columnFilter field="PeriodNo" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterPeriodNo
									[ngModel]="value"
									[options]="lstPeriodNo"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--InstructorDesc-->
					<th>
						<p-columnFilter field="InstructorDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterInstructorDesc
									[ngModel]="value"
									[options]="lstInstructorDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--DayDesc-->
					<th>
						<p-columnFilter field="DayDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterDayDesc
									[ngModel]="value"
									[options]="lstDayDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RoomNo-->
					<th>
						<p-columnFilter field="RoomNo" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRoomNo
									[ngModel]="value"
									[options]="lstRoomNo"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="CourseDesc">Course<p-sortIcon field="CourseDesc"></p-sortIcon></th>
					<th pSortableColumn="SectionNo">Section<p-sortIcon field="SectionNo"></p-sortIcon></th>
					<th pSortableColumn="Semester">Semester<p-sortIcon field="Semester"></p-sortIcon></th>
					<th pSortableColumn="PeriodNo">Period<p-sortIcon field="PeriodNo"></p-sortIcon></th>
					<th pSortableColumn="InstructorDesc">Instructor<p-sortIcon field="InstructorDesc"></p-sortIcon></th>
					<th pSortableColumn="DayDesc">Day<p-sortIcon field="DayDesc"></p-sortIcon></th>
					<th pSortableColumn="RoomNo">Room<p-sortIcon field="RoomNo"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Section>
				<tr [pSelectableRow]="Section">
					<td *ngFor="let col of cols" style="font-weight: bold">
						{{ Section[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
